import { useNavigate } from "react-router-dom";
import { isUserVirgin } from "../../api/auth";
import { useState } from "react";
import { ENDPOINTS } from "../../api/endpoints";
import PasswordReset from "./PasswordReset";

interface LoginProps {
  onLogin: (email: string, password: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [isUserVirginState, setIsUserVirginState] = useState<boolean>(false);
  const [email, setEmail] = useState(''); //demo@ampli-fi.io
  const [password, setPassword] = useState(''); // Password1
  const navigate = useNavigate();

  const handleLoginSubmit = async () => {
    try {
      await onLogin(email, password);
    } catch (error) {
      console.error('Error logging in ', error);
    }
  };

  const handleVirginUser = async () => {
    if (email) {
      try {
        // Assuming you have a function to check if the email is registered
        const response = await isUserVirgin(email);
        if (response.user && response.user.IsActivated === true && response.user.ForcePasswordReset === true) {
          sessionStorage.setItem('userId', response.user.Id)
          setIsUserVirginState(true);
        }
      } catch (error) {
        console.error('Error checking email: ', error);
      }
    }
  }

  return (
    <>
      {!isUserVirginState ? (
        <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 style={{ fontSize: '2em', color: '#4A90E2' }}>Quali-fi</h1>
          </div>
          <h2>Login Page</h2>
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={handleVirginUser}
            style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
          />
          <button onClick={handleLoginSubmit} style={{ width: '100%', padding: '10px', backgroundColor: '#4A90E2', color: 'white', border: 'none', borderRadius: '5px' }}>Login</button>
        </div>
        ) : (
          <PasswordReset onLogin={onLogin} userEmail={email}/>
        )
      }
    </>
  );
}

export default Login;